// Hook odpowiedzialny za pobranie listy produktóe "inni kupili"

import { axios } from 'api';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  IProductListItem
} from 'api/types';

// parametry requestu do api
export type IRequest = IPaginationRequest & {
  scopes?: string;
  productIds?: string;
};

// typ zwracanych danych
type IResponse = IPaginationResponse<IProductListItem>;

const getProductsBoughtByOthers = (id: number, params?: IRequest): Promise<IResponse> =>
  axios.get(`/products/${id}/products-bought-by-others`, { params });

export const useGetProductsBoughtByOthers = (
  id: number,
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['products-bought-by-others', id, params],
    () => getProductsBoughtByOthers(id, params),
    options
  );

export const useGetProductsBoughtByOthersMutation = (
  id: number,
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => getProductsBoughtByOthers(id, data), options);
